import React from "react";
import {
  VerticalLine,
  Container,
  CenterLine,
  TextWrapper,
  Yazdun,
  Copyright,
} from "./Footer.elements";

const Footer = () => {
  return (
    <>
      <CenterLine>
        <VerticalLine />
      </CenterLine>
      <Container>
        <TextWrapper>
          <Yazdun>طراحی و اجرا از یزدان</Yazdun>
        </TextWrapper>
        <TextWrapper>
          <Copyright>All Rights Reserved ® 2021</Copyright>
        </TextWrapper>
      </Container>
    </>
  );
};

export default Footer;
